import React from 'react';
import RecordsProgressive from './records-progressive';

const TransferRecords = () => {
  return <RecordsProgressive type="transfer" />;
};

export default TransferRecords;
